import { ReportValidity } from 'smg/form';
import * as phones from 'smg/phone';

if (document.body.id === 'forms') {
    // const $selectBtns = document.querySelectorAll('button[data-select]');
    // console.log($selectBtns);

    // $selectBtns.forEach($btn => {
    //     $btn.addEventListener('click', () => {
    //         console.log('btn clicked');
    //         const $select = document.querySelector(`#${$btn.getAttribute('data-select') || ''}`) as HTMLSelectElement;
    //         console.log($select);
    //         $select.dispatchEvent(new Event('change'));
    //     });
    // });

    const phoneEl = document.querySelector('#phone') as HTMLInputElement;
    const phoneElTwo = document.querySelector('#phone2') as HTMLInputElement;
    new phones.Phone(phoneEl);
    new phones.Phone(phoneElTwo);
    const $form = document.querySelector('#test-form') as HTMLFormElement;
    $form.noValidate = true;
    $form.addEventListener('submit', e => {
        e.preventDefault();
        if (!ReportValidity($form)) {
            return;
        }
    });

    const $form2 = document.querySelector('#test-form2') as HTMLFormElement;
    $form2.noValidate = true;
    $form2.addEventListener('submit', e => {
        e.preventDefault();
        if (!ReportValidity($form2)) {
            return;
        }
    });
}
